import { NgClass, NgStyle } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
    selector: 'ecm-mat-spinner',
    templateUrl: './material-spinner.html',
    styleUrls: ['./material-spinner.css'],
    standalone: true,
    imports: [NgClass, NgStyle],
})
export class MaterialSpinnerComponent {
    /**
     * Spinner center positioning
     * @type {boolean} centered
     */
    @Input() public centered = false;
    /**
     * Spinner custom text
     * @type {string} custom text
     */
    @Input() public text?: string;
    /**
     * Size of the spinner's circle in px. 50px by default
     * @type {string} size in px
     */
    @Input() public size?: string;
}
